export default __webpack_public_path__ + "static/media/Boots of the Beyond.e7b7cc71.jpg";